export enum ETipoLancamentoRastreabilidade {
    Manual = 1,
    Fifo = 2,
    Lifo = 3,
    Fefo = 4
}
